export default "__VITE_ASSET__BqAFCKCd__"